import { CompanyParamsService } from './../../../services/companyParams/company-params.service';
import { NgWebflowService } from 'ngweflow';
import { PurchaseRequestStatus } from './../../../enums/purchase-request-status.enum';
import { CountryService } from 'src/app/core/services/country/country.service';
import { MonthDay } from 'src/app/models/month-day';
import { Gender } from 'src/app/enums/gender.enums';
import { Month } from 'src/app/models/month';
import { Component, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl, RequiredValidator } from '@angular/forms';
import { Country } from 'src/app/models/country';
import { PurchaseRequestService } from '../../services/purchase-request/purchase-request.service';
import { MonthService } from 'src/app/core/services/month/month.service';
import { PurchaseCabin } from 'src/app/models/purchase-cabin';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { isNullOrUndefined } from 'util';
import { PassengerType } from 'src/app/enums/passenger-type.enum';
import { PurchaseCabinPassenger } from 'src/app/models/purchase-cabin-passenger';
import { PurchaseContactPerson } from 'src/app/ngGtcPayflow/models/purchase-contact-person';
import { PurchasePassengerInformation } from 'src/app/ngGtcPayflow/models/purchase-passenger-information';
import { CruiseService } from '../../services/cruise/cruise.service';
import * as $ from 'jquery';
import { UrlParamsService } from 'src/app/services/url-params.service';
import { environment } from 'src/environments/environment';
import { BookingConfirmationResponse } from 'src/app/models/purchase/booking-confirmation-response';
import { RoyalRequestService } from 'src/app/services/royal-request/royal-request.service';
import { PromoService } from '../../services/promo/promo.service';
import { Availability } from 'src/app/models/availability';
import { CodeProcesscrmEnum } from '../../../enums/code-process-crm.enum';
import { WebFlowAction } from 'src/app/enums/web-flow-action.enum';
import { SearchCountryField, CountryISO, TooltipLabel } from 'ngx-intl-tel-input-angular7';
import { PaymentMethodTypeEnum } from "../../../enums/payment-methods-type.enum-";

interface PurchaseContactPassengerListElement { cabinIndex: number; passengerIndex: number; }

@Component({
  selector: "app-checkout-second",
  templateUrl: "./checkout-second.component.html",
  styleUrls: ["./checkout-second.component.css"],
})
export class CheckoutSecondComponent implements OnInit {
  public activeEndSlide: string;
  public namesMinLength = 2;
  public passportMinLength = 5;
  public months: Month[] = [];
  public genders: typeof Gender = Gender;
  public countries: Country[] = [];
  public years: number[] = [];
  public days: MonthDay[] = [];
  private numberOfPassengers: number;
  public purchasePassengerForm: FormGroup;
  public purchaseCabinInformation: string[];
  public purchaseContactPassengersListElements: PurchaseContactPassengerListElement[];
  public minAge: number;
  public maxChildAge: number;
  public isShowErrorsSummary = false;
  public isAutoPaymentAccepted: boolean;
  public showPassportNumberRequiredModal: boolean;
  // private static GENDER_DEFAULT_VALUE: string = 'undefined';
  testFormArrays: FormArray[] = [];
  cabinsNumber: PurchaseCabin[];
  monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  howFindUsList: string[] = [
    "Internet search",
    "Recommendation from friend / family",
    "Social media channels",
    "Other",
  ];
  public cruise: any;
  public startEndDates: string;
  public startEndDatesType: string;
  public promotion: string;
  public priceWithAirFare: number;
  public itineraryIndex: number;
  public cruiseStartDate: string;
  public boatImagesResource: string;
  public position: boolean;
  public cruiseItineraryDuration: string;
  public availavilitySelected: Availability;
  geoIp = "";
  urlElementsArray: string[] = [];
  whatsappNumber: any;
  public visibleGuest: boolean = false;
  public formReady: boolean = false;
  public hasPlaceToPay: boolean = false;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;

  constructor(
    private fb: FormBuilder,
    private monthService: MonthService,
    private countryService: CountryService,
    private router: Router,
    public purchaseRequestService: PurchaseRequestService,
    private cruiseService: CruiseService,
    private ngWebflowService: NgWebflowService,
    public companyParamsService: CompanyParamsService,
    private urlParamsService: UrlParamsService,
    private royalRequestService: RoyalRequestService,
    private promoService: PromoService,
    private cdr: ChangeDetectorRef
  ) {
    $(document).ready(function () {
      $("html, body").animate(
        {
          scrollTop: $("#startCheckoutSecond").offset().top,
        },
        1000
      );
    });
  }

  ngOnInit() {
    if (!isNullOrUndefined(this.purchaseRequestService.purchase.cruise)) {
      this.activeEndSlide = "active";
      this.royalRequestService.getGeoIpDirection().subscribe((ip) => {
        this.geoIp = ip;
      });
      this.numberOfPassengers =
        this.purchaseRequestService.getNumberOfPassengers();
      this.months = this.monthService.getMonths();
      this.years = this.generateYears();
      this.countries = this.countryService.getCountries();
      this.hasPlaceToPay = this.companyParamsService.hasPlacetopayPaymentMethod();
      this.purchasePassengerForm = this.createPassengerForms(this.createContactForm());
      this.purchaseCabinInformation = this.getPurchaseCabinInformation();
      this.purchaseContactPassengersListElements =
        this.getPurchaseContactPassengersListElements();
      this.minAge = this.purchaseRequestService
        .getCruiseWrapper()
        .getEdadMinima();
      this.maxChildAge = this.purchaseRequestService
        .getCruiseWrapper()
        .getEdadNino();
      this.isAutoPaymentAccepted =
        this.purchaseRequestService.isAutoPaymentAccepted();
      this.showPassportNumberRequiredModal = false;

      const selecteIndex = 0;
      this.cruise = this.purchaseRequestService.purchase.cruise;
      this.cruiseStartDate =
        this.cruise.availability[this.cruise.iterIndex].date;
      this.availavilitySelected =
        this.cruise.availability[this.cruise.iterIndex];
      this.startEndDates =
        this.cruise.availability[this.cruise.iterIndex].startEndDates;
      this.startEndDatesType =
        this.cruise.availability[this.cruise.iterIndex].name;
      this.promotion =
        this.cruise.availability[this.cruise.iterIndex].promotion;

      this.itineraryIndex = selecteIndex;
      this.priceWithAirFare = this.cruiseService.getCruisePriceinNewFormat(
        this.cruise,
        this.itineraryIndex,
        true
      );
      this.cabinsNumber = this.purchaseRequestService.purchase.cabins;
      this.initializeBoatImageResource();
      this.position = true;
      this.cruiseItineraryDuration = this.purchaseRequestService
        .getCruiseWrapper()
        .getCruiseItineraryDuration();
    } else {
      window.location.href = window.location.href.substring(
        0,
        window.location.href.length - 1
      );
    }
    this.whatsappNumber = this.companyParamsService.getCompanyParams().whatsappNumber;
    this.formReady = true;
    this.subscribeToPhoneChanges();
  }

  private subscribeToPhoneChanges(): void {
    // Subscribe a cambios del teléfono internacional
    const contactForm = this.purchasePassengerForm.get("purchaseContactPersonForm");
    if (contactForm) {
      const itiObjectControl = contactForm.get("itiObject");
      if (itiObjectControl) {
        itiObjectControl.valueChanges.subscribe((value: any) => {
          if (value && value.dialCode && value.number) {
            const phoneValue = value.dialCode + value.number;
            contactForm.get("phone").setValue(phoneValue, { emitEvent: false });
          }
        });
      }
    }
  }

  createUrlLogoCruise() {
    return environment.app_resources.logoCruise + this.cruise.logo;
  }
  public getMonthDays(cabinIndex: number, passengerIndex: number): MonthDay[] {
    try {
      const birthMonth: number = this.purchasePassengerForm
        .get("purchasePassengers")
        .get(cabinIndex.toString())
        .get(passengerIndex.toString())
        .get("birthMonth").value as number;
      const birthYear: number = this.purchasePassengerForm
        .get("purchasePassengers")
        .get(cabinIndex.toString())
        .get(passengerIndex.toString())
        .get("birthYear").value as number;
      if (isNullOrUndefined(birthMonth) || isNullOrUndefined(birthYear)) {
        return [];
      }
      return UtilsService.generateMonthDays(birthMonth, birthYear);
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  private getPurchaseContactPassengersListElements(): PurchaseContactPassengerListElement[] {
    try {
      const purchaseContactPassengerListElements: PurchaseContactPassengerListElement[] =
        [];
      this.purchaseRequestService.purchase.cabins.forEach(
        (purchaseCabin: PurchaseCabin, cabinIndex: number) => {
          purchaseCabin.purchaseCabinPasssengers.forEach(
            (
              purchaseCabinPassenger: PurchaseCabinPassenger,
              passengerIndex: number
            ) => {
              if (purchaseCabinPassenger.type === PassengerType.ADULT) {
                purchaseContactPassengerListElements.push({
                  cabinIndex: Number(cabinIndex),
                  passengerIndex: Number(passengerIndex),
                });
              }
            }
          );
        }
      );
      return purchaseContactPassengerListElements;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  private getPurchaseCabinInformation(): string[] {
    try {
      return this.purchaseRequestService
        .getPurchaseCabinObjectSummary()
        .map(
          (purchaseCabinObjectSummary: {
            cabinaItinerarioNombre: string;
            camaCabinaNombre: string;
          }) => {
            return (
              purchaseCabinObjectSummary.cabinaItinerarioNombre +
              " / " +
              purchaseCabinObjectSummary.camaCabinaNombre
            );
          }
        );
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  private createPassengerForms(contactForm: FormGroup): FormGroup {
    try {
      const formArrays: FormArray[] = [];
      this.purchaseRequestService.purchase.cabins.forEach(
        (purchaseCabin: PurchaseCabin) => {
          const formArrayForCabin: FormArray =
            this.createFormArrayForCabin(purchaseCabin);
          formArrays.push(formArrayForCabin);
        }
      );
      this.purchasePassengerForm = this.fb.group({
        purchasePassengers: new FormArray(formArrays),
        purchaseContactPersonForm: contactForm,
      });
      return this.purchasePassengerForm;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  get agencyValue() {
    return this.purchasePassengerForm
      .get("purchaseContactPersonForm")
      .get("agency").value;
  }

  get commentsValue() {
    return this.purchasePassengerForm
      .get("purchaseContactPersonForm")
      .get("comments").value;
  }
  get emailValue() {
    return this.purchasePassengerForm
      .get("purchaseContactPersonForm")
      .get("email").value;
  }

  get phoneValue() {
    return this.purchasePassengerForm
      .get("purchaseContactPersonForm")
      .get("phone").value;
  }
  get firstNameValue() {
    return this.purchasePassengerForm
      .get("purchaseContactPersonForm")
      .get("purchasePassenger").value;
  }

  get firstName() {
    return this.purchasePassengerForm
      .get("purchaseContactPersonForm")
      .get("firstName").value;
  }

  get lastName() {
    return this.purchasePassengerForm
      .get("purchaseContactPersonForm")
      .get("lastName").value;
  }

  get passport() {
    return this.purchasePassengerForm
      .get("purchaseContactPersonForm")
      .get("passport").value;
  }

  private createFormArrayForCabin(purchaseCabin: PurchaseCabin): FormArray {
    try {
      const cabinFormGroup: FormGroup[] = [];
      const numberOfAdultsArray: number[] =
        UtilsService.getArrayOfNumbersByRange(0, purchaseCabin.adults - 1);
      const numberOfChildrenArray: number[] =
        UtilsService.getArrayOfNumbersByRange(0, purchaseCabin.children - 1);

      numberOfAdultsArray.forEach(() => {
        cabinFormGroup.push(this.visibleGuest ? this.createPassagerForm(PassengerType.ADULT) : this.createPassagerFormNoValidate(PassengerType.ADULT));
      });

      numberOfChildrenArray.forEach(() => {
        cabinFormGroup.push(this.visibleGuest ? this.createPassagerForm(PassengerType.CHILD) : this.createPassagerFormNoValidate(PassengerType.CHILD));
      });
      return new FormArray(cabinFormGroup);
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  private createPassagerFormNoValidate(passengerType: PassengerType): FormGroup {
    const value = this.fb.group(
      {
        firstName: this.visibleGuest ? '' : ['no data'],
        lastName: this.visibleGuest ? '' : ['no data'],
        localFlight: this.visibleGuest ? '' : ['no data'],
        gender: this.visibleGuest ? '' : ['no data'],
        country: this.visibleGuest ? '' : ['no data'],
        passport: this.visibleGuest ? '' : ['no data'],
        birthday: this.visibleGuest ? '' : ['01'],
        birthMonth: this.visibleGuest ? '' : ['01'],
        birthYear: this.visibleGuest ? '' : ['2020'],
        address: this.visibleGuest ? '' : ['no data'],
        allergies: this.visibleGuest ? '' : ['no data'],
        passengerType: [passengerType,],
      },
    );
    return value;
  }

  private createPassagerForm(passengerType: PassengerType): FormGroup {
    try {
      return this.fb.group(
        {
          firstName: [
            null,
            [Validators.required, Validators.minLength(this.namesMinLength)],
          ],
          lastName: [
            null,
            [Validators.required, Validators.minLength(this.namesMinLength)],
          ],
          gender: [null, Validators.required],
          country: [null, Validators.required],
          passport: [null, Validators.required],
          birthday: [null, Validators.required],
          birthMonth: [null, Validators.required],
          birthYear: [null, Validators.required],
          passengerType: [passengerType, Validators.required],
        },
        { validator: this.birthDateValidator.bind(this) }
      );
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  private createContactForm(): FormGroup {
    try {
      let contactFormGroup: FormGroup;
      const passportValidators = this.hasPlaceToPay
        ? [Validators.required, Validators.minLength(4), Validators.maxLength(16)]
        : [];
      const purchaseContactPerson = {
        passport: [null as string, passportValidators],
        firstName: [null as string, [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/)]],
        lastName: [null as string, [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/)]],
        email: [null as string, [Validators.required, Validators.email]],
        phone: [null as string, [Validators.required, Validators.pattern(/^\+?[0-9\s\-()]+$/)]],
        agency: "",
        comments: "",
        howFindUs: "",
        valueOther: "",
        purchasePassenger: [0 as number, Validators.required],
        itiObject: [null, [Validators.required]]
      };
      contactFormGroup = this.fb.group(purchaseContactPerson);
      return contactFormGroup;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  private birthDateValidator(passengerForm: FormGroup): {
    notAllowedBirtdate?: boolean;
    notChild?: boolean;
    birthdateError?: boolean;
  } {
    try {
      if (
        isNullOrUndefined(passengerForm.get("birthYear").value) ||
        isNullOrUndefined(passengerForm.get("birthMonth").value) ||
        isNullOrUndefined(passengerForm.get("birthday").value)
      ) {
        return { birthdateError: true };
      }

      const selectedBirthDate: Date = UtilsService.getDate(
        passengerForm.get("birthYear").value,
        passengerForm.get("birthMonth").value,
        passengerForm.get("birthday").value
      );
      const childMinDate = this.purchaseRequestService
        .getCruiseWrapper()
        .getMinBirthDateForChild();
      const childMaxDate = this.purchaseRequestService
        .getCruiseWrapper()
        .getMaxBirthDateForChild();

      if (
        isNullOrUndefined(selectedBirthDate) ||
        isNullOrUndefined(childMinDate) ||
        isNullOrUndefined(childMaxDate)
      ) {
        return { birthdateError: true };
      }
      if (selectedBirthDate > childMinDate) {
        return { notAllowedBirtdate: true };
      } else if (
        passengerForm.get("passengerType").value === PassengerType.CHILD &&
        (selectedBirthDate > childMinDate || selectedBirthDate < childMaxDate)
      ) {
        return { notChild: true };
      }
      return null;
    } catch (error) {
      console.error(error);
      return { birthdateError: true };
    }
  }

  public goBack(): void {
    try {
      this.purchaseRequestService.purchaseRequestStatus =
        PurchaseRequestStatus.INITIAL;
    } catch (error) {
      console.error(error);
    }
  }

  public confirm(
    purchasePassengersInformation,
    purchaseContactPerson: {
      passport: string;
      firstName: string;
      lastName: string;
      email: string;
      phone: string;
      agency: string;
      comments: string;
      purchasePassenger: number;
      howFindUs: string;
      valueOther: string;
      itiObject: any;
    }
  ): void {
    try {
      if (this.purchasePassengerForm.invalid === true) {
        this.validateAllFormFields(this.purchasePassengerForm);
        this.testFormArrays = this.getPurchasePassengerFormControls();
        /**
         * implementacion de validacion de forms para los pasajeros
         */
        this.testFormArrays.forEach((element) => {
          const elementFormArray = element as FormArray;
          elementFormArray.controls.forEach((formgroupPassengers) => {
            const formgroupPasen: FormGroup = formgroupPassengers as FormGroup;
            this.validateAllFormFields(formgroupPasen);
          });
        });

        this.isShowErrorsSummary = true;
        return;
      }

      this.purchaseRequestService.addPurchasePassengersInformation(
        purchasePassengersInformation
      );
      this.purchaseRequestService.addPurchaseContectPerson(
        this.validateContactPerson(
          purchaseContactPerson,
          purchasePassengersInformation
        )
      );
      this.purchaseRequestService.purchaseRequestStatus =
        PurchaseRequestStatus.PASSENGER_COMPLETED;
      const dataPassenger = {
        passengers: purchasePassengersInformation,
        contactPerson: purchaseContactPerson,
      };
      this.ngWebflowService.addWebFlowAction(
        WebFlowAction.FILL_PASSENGER_FORM,
        dataPassenger
      );
      this.ngWebflowService.addWebFlowAction(
        WebFlowAction.BOOKING_START,
        { message: 'booking start' },
      );
      if (this.companyParamsService.getVisiblepago()) {
        this.router.navigate([this.urlParamsService.createurlForNextPage("3")]);
      } else {
        this.requestBookingConfirmation();
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  private requestBookingConfirmation(): void {
    try {
      this.purchaseRequestService.requestInquireConfirm().subscribe(
        (bookingConfirmationResponse: BookingConfirmationResponse) => {
          if (
            this.purchaseRequestService.isRequestBookingConfirmationSuccess(
              bookingConfirmationResponse
            )
          ) {
            this.purchaseRequestService.purchaseRequestStatus =
              PurchaseRequestStatus.BOOCKING_CONFIRMATION_SENT;
            this.router.navigate([
              this.urlParamsService.createurlForNextPage("4"),
            ]);
          }
        },
        (error: any) => {
          this.ngWebflowService.addWebFlowAction(WebFlowAction.SEND_INQUIRE_FAILED, {
            result: "failed",
            response: error,
            body: {
              ...this.purchaseRequestService.preparePurchaseObjectToRequestBookingConfirmation(),
            },
          });
          console.error(error);
        },
        () => {
          this.ngWebflowService.addWebFlowAction(WebFlowAction.SEND_INQUIRE_SUCCESS, {
            result: "ok",
          });
        }
      );
    } catch (error) {
      console.log("BookTourComponent.requestbookingConfirm()");
      console.error(error);
      this.ngWebflowService.addWebFlowAction(WebFlowAction.SEND_INQUIRE_ERROR, { result: "error", response: error });
    }
  }

  public getPromoName(itineraryIndex: number): string {
    try {
      return (
        this.promoService.getPromoText(
          this.cruise.availability[itineraryIndex].promotionType,
          this.cruise.availability[itineraryIndex].promotionValue
        ) || ""
      );
    } catch (error) {
      console.log("ResultsComponent.getPromoName()");
      console.error(error);
      return null;
    }
  }

  getStringFormDatailRoyal(promoText: string): string {
    let product = this.royalRequestService.getNameBoatToRoyal(this.cruise.name);
    let resp = "none" + "/" + product + "/" + promoText + "/";
    this.urlElementsArray.push("none");
    this.urlElementsArray.push(product);
    this.urlElementsArray.push(promoText);
    // let resp = (services === "" ? "none" : services.substring(0, services.length - 1)) + "/" + product + "/" + promoText + "/";
    return resp;
  }

  // controla si el control es valido caso contrario lo pinta este metodo sirve para cualquier form

  public validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  public getCountries(): Country[] {
    try {
      return this.countryService.getCountries();
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  nextThirdPart() {
    this.router.navigate([this.urlParamsService.createurlForNextPage("3")]);
  }

  public isFormValid(): boolean {
    try {
      this.purchasePassengerForm
        .get("purchaseContactPersonForm")
        .get("purchasePassenger")
        .updateValueAndValidity();
      return this.purchasePassengerForm.valid;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  private validateContactPerson(
    purchaseContactPersonForm: {
      passport: string;
      firstName: string;
      lastName: string;
      email: string;
      phone: string;
      agency: string;
      comments: string;
      howFindUs: string;
      valueOther: string;
      purchasePassenger: number;
      itiObject: any;
    },
    purchasePassengersInformation: PurchasePassengerInformation[][]
  ): PurchaseContactPerson {
    try {

      const purchaseContactPerson: PurchaseContactPerson =
        this.createPurchaseContactPerson(purchaseContactPersonForm);
      return purchaseContactPerson;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  createPurchaseContactPerson(purchaseContactPersonForm: {
    passport: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    agency: string;
    comments: string;
    howFindUs: string,
    valueOther: string,
    purchasePassenger: number;
    itiObject:any;
  }): PurchaseContactPerson {
    console.log(purchaseContactPersonForm);
    let purchaseContactPerson: PurchaseContactPerson;
    purchaseContactPerson = {
      passport: purchaseContactPersonForm.passport,
      firstName: purchaseContactPersonForm.firstName,
      lastName: purchaseContactPersonForm.lastName,
      phone: purchaseContactPersonForm.phone,
      agency: this.getCorrectValue(purchaseContactPersonForm.agency.trim()),
      remarks: this.getCorrectValue(purchaseContactPersonForm.comments.trim()),
      email: purchaseContactPersonForm.email,
      howFindUs: this.getCorrectValue(purchaseContactPersonForm.howFindUs),
      valueOther: this.getCorrectValue(purchaseContactPersonForm.valueOther),
      purchasePassengerInformation: null,
      itiObject:purchaseContactPersonForm.itiObject
    };
    return purchaseContactPerson;
  }

  getCorrectValue(text: any) {
    return text && text !== "" ? text : "Not specific";
  }
  public trackByFn(index: any, item: any) {
    return index;
  }


  public generateYears(): number[] {
    try {
      const years: number[] = [];
      const date = new Date();
      const startAt = date.getFullYear() - 100;

      const endAt =
        date.getFullYear() -
        this.purchaseRequestService.purchase.cruise.minimumAgeChild;
      // const endAt = date.getFullYear() - 10;

      for (let i = startAt; i <= endAt; i++) {
        years.push(i);
      }
      return years.sort((a, b) => b - a);
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  public getPurchasePassengerFormControls(): FormArray[] {
    try {
      return (
        this.purchasePassengerForm.controls.purchasePassengers as FormArray
      ).controls as FormArray[];
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  public toggleShowPassportNumberRequiredModal(): void {
    try {
      this.showPassportNumberRequiredModal =
        !this.showPassportNumberRequiredModal;
    } catch (error) {
      console.error(error);
    }
  }

  private initializeBoatImageResource(): void {
    this.boatImagesResource =
      environment.app_resources.logoCruise + this.cruise.image;
  }
  reset() {
    this.formReady = false;
    this.purchasePassengerForm = this.createPassengerForms(this.createContactForm());
    this.visibleGuest = false;
    setTimeout(() => {
      this.formReady = true;
      this.cdr.detectChanges();
      this.subscribeToPhoneChanges();
      $("html, body").animate(
        {
          scrollTop: $("#startCheckoutSecond").offset().top,
        },
        1000
      );
    }, 50);
  }

  addLogEmail() {
    this.ngWebflowService.addWebFlowAction(
      WebFlowAction.MAIN_CONTACT_PERSON_EMAIL,
      { contactPersonEmail: this.purchasePassengerForm.value.purchaseContactPersonForm.email },
      true
    );
  }

  /**
   * Deshabilita un campo de un formulario
   * @param event
  */
  onCheckboxChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.visibleGuest = inputElement.checked;
    this.purchasePassengerForm = this.createPassengerForms(this.purchasePassengerForm.get("purchaseContactPersonForm") as FormGroup);
  }

}
